import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Card, Alert, Row, Col } from 'react-bootstrap';
import Api, { BaseUrl } from '../../../../api/Api';

const JsonProcessorV2 = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [fileContent, setFileContent] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    setError('');
    setSuccess('');
    const file = e.target.files[0];
    
    if (!file) return;

    if (file.type !== "application/json") {
      setError('Пожалуйста, загрузите файл в формате JSON');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const content = JSON.parse(event.target.result);
        setFileContent(content);
      } catch (err) {
        setError('Невалидный JSON файл');
        console.error('Ошибка парсинга JSON:', err);
      }
    };
    reader.readAsText(file);
  };

  const onSubmit = async(formData) => {
    if (!fileContent) {
      setError('Пожалуйста, загрузите JSON файл');
      return;
    }

    try {
      const result = {
        // "name": formData.name,
        // "description": formData.description,
        "name":fileContent["name"],
        "description":fileContent["description"],
        "coefficients":fileContent["coefficients"],
        "data": fileContent["data"]
        // "data": fileContent
      }; 
      const response=await Api({
        method:"post",
        url:`/tests/add`,
        headers:{},
        data:result
      }) 
      setSuccess('Файл успешно обработан и загружен.');
      alert('Файл теста загружен');
    } catch (error) {
      // alert("Ошибка при создании теста.");
      alert(error);
    }
  };
  const test_text_exsample="{\"name\":*название версии ДК ТОС,\n \"description\":*описание,\n \"coefficients\"*коэфициенты разделов:{*название раздела:*коэфициент(1.00), ...},\n \"data\":{*Структура ДК ТОС} }"

  return (
        <Form onSubmit={handleSubmit(onSubmit)} className="text_font">
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>
              <p style={{whiteSpace:"pre-wrap"}}>
                Загрузите JSON файл.<br/> 
                Структура:<br/> 
                {test_text_exsample}
                </p></Form.Label>
            <Form.Control 
              type="file" 
              accept=".json,application/json"
              onChange={handleFileChange}
            />
            <Form.Text className="text_font">
              Файл должен быть в формате JSON
            </Form.Text>
          </Form.Group>

          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}

          <div className="mt-2">
            <Row>
                <Col ></Col>
                <Col >
                  <Button className="custom-btn free-btn" type="submit" size='lg'>
					Загрузить
				</Button>
                </Col>
            </Row>
          </div>
        </Form>
  );
};

export default JsonProcessorV2;